// Side effect: registers all base unit tactics
import "./data/tactics";

export { applyDrawPhase } from "./appliers/apply-draw-phase";
export * from "./appliers/index";
export type {
  ColDef,
  ColMode,
  Direction,
  HexCoord,
} from "./data/index";
export {
  ALL_HEX_ID_SET,
  ALL_HEX_IDS,
  assertWarChestLocationContext,
  BASE_UNIT_IDS,
  BASE_UNITS,
  BOARDS,
  COINS_PER_UNIT_IN_BAG,
  COL_DEFS,
  CONTROL_MARKERS_TO_WIN,
  colRowToPx,
  DEFAULT_BOARD_ID,
  DEFAULT_CONFIG,
  DIR_VECTORS,
  EDGE_HEX_ID_SET,
  EDGE_HEX_IDS,
  formatHexId,
  generateBaseBoard,
  HAND_DRAW_COUNT,
  hexPath,
  LOCATIONS,
  LOCATIONS_2P,
  LOCATIONS_4P,
  listHexCoords,
  NEUTRAL_LOCATIONS_2P,
  PLAY_HEX_ID_SET,
  PLAY_HEX_IDS,
  parseHexId,
  SIDE_LOCATIONS_4P_ONLY,
  STARTING_BOTTOM_2P,
  STARTING_RAVEN,
  STARTING_TOP_2P,
  STARTING_WOLF,
} from "./data/index";
export type { InitGameOptions } from "./init-game";
export {
  buildPlayerZones,
  createGame,
  initDraftGame,
  initGame,
} from "./init-game";

export { redactGameState } from "./redact";
export type { ReduceResult } from "./reduce-game-state";
export {
  applyAction,
  reduceGameState,
  validateAction,
} from "./reduce-game-state";
export * from "./types/index";
export * from "./utils/index";
export * from "./validators/index";
